import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, notify } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import { getBrandFontsLink } from 'packages/helpers/defaultLinks';
import { replaceRequest } from 'packages/store/fontManagement/fontManagement.selectors';

const REMINDER_ID = 'brand-fonts-replace';

const ReplaceFontReminder = () => {
    const { translate } = useTranslate();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const request = useSelector(replaceRequest);
    const isAwayFromFonts = request !== undefined && pathname !== getBrandFontsLink();

    useEffect(() => {
        if (!isAwayFromFonts) {
            notify.remove(REMINDER_ID);

            return;
        }

        notify({
            id: REMINDER_ID,
            isPersistent: true,
            title: translate('pages.brand.fonts.upload.replace.title'),
            description: translate('pages.brand.fonts.upload.replace.reminder'),
            button: (
                <Button onClick={() => navigate(getBrandFontsLink())}>
                    {translate('pages.brand.fonts.upload.replace.goToFonts')}
                </Button>
            ),
        });
    }, [isAwayFromFonts, navigate, translate]);

    return null;
};

export default ReplaceFontReminder;
